<template>
    <div class="rDetailBlock">
        <!--状态栏-->
        <!--<status-bar :data="data"></status-bar>-->
        <!--基础信息，联系信息，求职意向-->
        <base-info :baseInfo="item"></base-info>
        <!--简历关键词-->
        <resume-keyword :resume-info="item" v-if="item.keywordList && item.keywordList.length > 0"></resume-keyword>
        <!--工作经历-->
        <work-experience :resumeInfo="item" v-if="item.workExperienceList && item.workExperienceList.length > 0"></work-experience>
        <!--项目经历-->
        <project-experience :resumeInfo="item" v-if="item.projectExperienceList && item.projectExperienceList.length > 0"></project-experience>
        <!--竞赛经历-->
        <competition-experience :resumeInfo="item"  v-if="item.competitionExperienceList && item.competitionExperienceList.length > 0"></competition-experience>
        <!--教育经历-->
        <education-experience :resumeInfo="item"  v-if="item.educationExperienceList && item.educationExperienceList.length > 0"></education-experience>
        <!--培训经历-->
        <training-experience :resumeInfo="item"  v-if="item.trainingExperienceList && item.trainingExperienceList.length > 0"></training-experience>
        <!--技能-->
        <skill :resumeInfo="item"  v-if="item.skillList && item.skillList.length > 0"></skill>
        <!--语言-->
        <language :resumeInfo="item"  v-if="item.languageList && item.languageList.length > 0"></language>
        <!--证书-->
        <cert :resumeInfo="item"  v-if="item.certList && item.certList.length > 0"></cert>
        <!--附件-->
        <!--<attachment :resumeInfo="item"></attachment>-->
        <!--<div class="fullResume">-->
    </div>
</template>
<script>
    import StatusBar from './StatusBar.vue';
    import BaseInfo from './BaseInfo.vue';
    import WorkExperience from './WorkExperience.vue';
    import ProjectExperience from './ProjectExperience.vue';
    import CompetitionExperience from './CompetitionExperience.vue';
    import EducationExperience from './EducationExperience.vue';
    import TrainingExperience from './TrainingExperience.vue';
    import Professional from './Professional.vue';
    import Skill from './Skill.vue';
    import Language from './Language.vue';
    import Cert from './Cert.vue';
    import Attachment from './Attachment.vue';
    import ResumeKeyword from './ResumeKeyword.vue';
    import {queryResume} from '@/api/resume';

    export default {
        props: ['item'],
        data() {
            return {
                // 登录url路径
                loginUrl: '/login',
            };
        },
        created() {
        },
        methods: {
            gotoResumeManage() {
                this.$store.commit('gotoEnterprise', {
                    check: true,
                    targetUri: '/backend#/manage/resume'
                });
            }
        },
        components: {
            StatusBar,
            BaseInfo,
            WorkExperience,
            ProjectExperience,
            CompetitionExperience,
            EducationExperience,
            TrainingExperience,
            Professional,
            Skill,
            Language,
            Cert,
            Attachment,
            ResumeKeyword
        }
    };
</script>